import {httpGetProjectMedicalDevices} from '@/features/projects/http/projects.http'
import {MedicalDevice} from '@/features/projects/types'
import {QUERY_KEYS} from '@/queryClient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'

interface UseGetProjectMedicalDevicesOptions {
    urlParams: {
        projectId: string
    }
    options?: Omit<UseQueryOptions<MedicalDevice[]>, 'queryKey' | 'queryFn'>
}

export const useGetProjectMedicalDevices = ({urlParams, options}: UseGetProjectMedicalDevicesOptions) => {
    return useQuery({
        queryKey: [QUERY_KEYS.PROJECT_MEDICAL_DEVICES, urlParams.projectId],
        queryFn: () => httpGetProjectMedicalDevices({urlParams}),
        ...options
    })
}
